export const pGetShippingPrice = (shipping_order, is_original) => {
  if (shipping_order.shipping_price == null) throw new Error('no shipping_order.shipping_price');
  const price = shipping_order.shipping_price;
  if (is_original) return price;
  if (shipping_order.refund_shipping_price == null)
    throw new Error('no shipping_order.refund_shipping_price');
  return price - shipping_order.refund_shipping_price;
};
